export default __webpack_public_path__ + "static/media/close-black.ba153a6d.svg";